import createReducer from 'legacy/src/shared/util/createReducer';
import { fetchTags } from './actions';

const initialState = {
  data: [],
  loading: false,
};

const reducer = createReducer(initialState, {
  [fetchTags.request]: (state) => ({
    ...state,
    loading: true,
  }),
  [fetchTags.success]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [fetchTags.failure]: (state) => ({
    ...state,
    loading: false,
  }),
});

export default reducer;
